import { OffersFilters } from './types';

export const getTableColumns = (t: any, showActions: boolean = true) => {
  const columns = [
    { name: t('revshare.table.columns.account'), key: 'account' },
    {
      name: t('revshare.table.columns.revshareDetails') || 'Детали RevShare',
      key: 'revshare_details',
    },
    { name: t('revshare.table.columns.statistics') || 'Статистика', key: 'statistics' },
  ];

  if (showActions) {
    columns.push({ name: t('revshare.table.columns.actions'), key: 'actions' });
  }

  return columns;
};

export const DEFAULT_PAGE_SIZE = 10;
export const MINIMUM_DEPOSIT = 200;

export const DEFAULT_FILTERS: OffersFilters = {
  search: '',
  sortBy: 'all',
  type: 'all',
};

export const SEARCH_DEBOUNCE_DELAY = 500;

export const getSortOptions = (t: any) => [
  { key: '-created_at', label: t('revshare.offers.filters.date') },
  { key: 'created_at', label: t('revshare.offers.filters.date') },
  { key: '-offer.commission', label: t('revshare.offers.filters.commission') },
  { key: 'offer.commission', label: t('revshare.offers.filters.commission') },
  { key: '-of_data.subscribers', label: t('revshare.offers.filters.subscribers') },
  { key: 'of_data.subscribers', label: t('revshare.offers.filters.subscribers') },
  { key: '-of_data.likes', label: t('revshare.offers.filters.likes') },
  { key: 'of_data.likes', label: t('revshare.offers.filters.likes') },
  { key: '-of_data.overall_popularity_percent', label: t('revshare.offers.filters.popularity') },
  { key: 'of_data.overall_popularity_percent', label: t('revshare.offers.filters.popularity') },
];

export const getTypeOptions = (t: any) => [
  { key: 'all', label: t('revshare.offers.filters.allTypes') },
  { key: 'free', label: t('revshare.offers.filters.free') },
  { key: 'free trial', label: t('revshare.offers.filters.freeTrial') },
];
